<template>
  <div
    class="page"
    :class="{'page--active': menuOpen }"
  >
    <div
      class="page__overlay"
      @click="closeMenu"
    />
    <v-sidebar
      class="page__sidebar"
      :class="{'page__sidebar--active': menuOpen }"
    />
    <div class="page__wrap">
      <v-header />
      <main
        class="page__content"
        aria-label="content"
      >
        <v-alert
          v-for="({message, type}, index) in alerts"
          :key="index"
          is-dismissible
          :color="type"
          icon="notification"
          @dismiss="clearAlert(index)"
        >
          {{ message }}
        </v-alert>
        <v-breadcrumbs
          :breadcrumbs="breadcrumbs"
        />
        <slot />
        <div class="page__copyright">
          Copyright © {{ year }} National Association of Testing Authorities, Australia |
          <router-link to="/terms-conditions">
            Terms and Conditions
          </router-link>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import Sidebar from "@/organisms/Sidebar";
  import Header from "@/organisms/Header";
  import Alert from "@/atoms/Alert";
  import Breadcrumbs from "@/molecules/Breadcrumbs";

  export default {
    components: {
      "v-sidebar": Sidebar,
      "v-header": Header,
      "v-alert": Alert,
      "v-breadcrumbs": Breadcrumbs
    },
    props: {},
    computed: {
      ...mapState({
          menuOpen: state => state.menu.menuOpen,
          alerts: state => state.alerts.alerts,
          breadcrumbs: state => state.breadcrumb.breadcrumbs
        }
      ),
      year(){
        return new Date().getFullYear();
      }
    },
    methods: {
      closeMenu: function () {
        this.$store.commit('changeMenu', false, {module: 'menu'})
      },
      clearAlert: function (index) {
        this.$store.commit('remove', index, {module: 'alerts'})
      }
    }
  };
</script>

<style lang="scss">
  @import "../../styles/shared/shared";

  .page {
    $this: &;
    position: relative;
    display: flex;
    min-height: 100%;
    background-color: $selago;
    &--active {
      #{$this}__overlay {
        display: block;
      }
    }
    &__wrap {
      position: relative;
      display: flex;
      flex-direction: column;
      overflow-x: hidden;
      flex: 1;
    }
    &__overlay {
      position: absolute;
      z-index: $z-page-overlay;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: none;
      background-color: rgba($black, .5);
      transition: opacity .15s ease;
      @include minpoint(tablet) {
        display: none;
      }
    }
    &__content {
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      padding: 10px 15px;
      @include minpoint(tablet) {
        padding: $page-gutter $page-gutter 10px $page-gutter;
      }
    }
    &__copyright{
      font-size:85%;
      padding-top:15px;
      text-align:center;
      line-height:1.3;
      @include minpoint(tablet) {
        text-align:left;
      }
    }
    &__sidebar {
      position: fixed;
      top: 0;
      bottom: 0;
      width: 240px;
      z-index: $z-sidebar;
      transform: translateX(-100%);
      transition: transform .15s ease;
      @include minpoint(tablet) {
        position: relative;
        transform: translateX(0);
      }
      &--active {
        transform: translateX(0);
        box-shadow: 3px 10px 4px 0 rgba(9, 33, 57, 0.2);
      }
    }
  }
</style>
